<axis-card id="outstandingCard">
  <axis-card-heading class="border-condensed">
    <axis-card-heading-body>
      <h1 class="axis-h3">Outstanding State Selections</h1>
      @if (
        !isStatePageEmptyScoped && statesFormArray.controls.length > 1 && (!reactiveForm.valid || showValidationError)
      ) {
        <axis-alert class="_mt-large"> Please enter your selections for the below. </axis-alert>
      }
    </axis-card-heading-body>
  </axis-card-heading>
  <axis-card-body>
    <form
      [formGroup]="reactiveForm"
      #outstandingContainer
      (ngSubmit)="onContinue()"
    >
      @if (isStatePageEmptyScoped) {
        <div class="initial-empty-container">
          <img
            alt=""
            class="axis-img-responsive _mlr-auto"
            src="assets/images/messages/no-manuscript.svg"
            loading="lazy"
          />
          <p class="_text-large _text-bold">No States Require Additional Selections</p>
          <p>Continue to Electronic Signature</p>
        </div>
      }
      <ng-template #stateComponent></ng-template>
    </form>
  </axis-card-body>
</axis-card>
<div class="axis-btn-wrapper">
  <div class="axis-btn-wrapper-left">
    <button
      axis-button
      class="kind-secondary"
      (click)="onBack()"
    >
      <span class="axis-btn-icon-text">Back</span>
    </button>
  </div>
  <div class="axis-btn-wrapper-right">
    <button
      axis-button
      class="kind-primary"
      (click)="onContinue()"
    >
      <span class="axis-btn-icon-text">Continue</span>
    </button>
  </div>
</div>
